// import notify from "../components/notify";
import axios from 'axios';
import { makeAutoObservable } from "mobx";
import Service from "../service/service";

const baseUrl = process.env.REACT_APP_API_BASE;

class BookingStore {
  constructor(rootStore) {
    this.rootStore = rootStore;
    makeAutoObservable(this);
  }

  async getCityList(payload, callback) {
    await Service.get("api/v3/web/city", payload, async (response) => {
      return callback(response);
    }).catch((error) => {
      return callback(error)
    });
  }

  async getCenterList(params, callback) {
    await Service.get(`api/v3/web/space?${params}`, async (response) => {
      return callback(response);
    }).catch((error) => {
      return callback(error)
    });
  }

  async getMeetingSlot(params, callback) {
    await Service.get(`api/v3/meeting/slots?${params}`, async (response) => {
      return callback(response);
    }).catch((error) => {
      return callback(error)
    });
  }

  async getFnbList(params, callback) {
    await Service.get(`api/v3/web/fnb/items?${params}`, async (response) => {
      return callback(response);
    }).catch((error) => {
      return callback(error)
    });
  }

  async applyCoupon(payload, callback) {
    await Service.post(`api/v3/web/applycoupon`, payload, async (response) => {
      return callback(response);
    }).catch((error) => {
      return callback(error)
    });
  }

  async inventoryPrice(params, callback) {
    await Service.get(`api/v3/web/inventoryprice?${params}`, async (response) => {
      return callback(response);
    }).catch((error) => {
      return callback(error)
    });
  }

  async getCampaign(params, callback) {
    await Service.get(`api/v3/web/campaign?${params}`, async (response) => {
      return callback(response);
    }).catch((error) => {
      return callback(error)
    });
  }

  async getCheckAvailability(params, callback) {
    await Service.get(`api/v3/web/checkavailability?${params}`, async (response) => {
      return callback(response);
    }).catch((error) => {
      return callback(error)
    });
  }

  async getPaymentLink(payload, callback) {
    await Service.post('api/v3/web/booking/payment',payload, async (response) => {
      return callback(response);
    }).catch((error) => {
      return callback(error)
    });
  }

  async getLeadForm(payload, callback) {
    await Service.post('api/v3/web/visit',payload, async (response) => {
      return callback(response);
    }).catch((error) => {
      return callback(error)
    });
  }

  async getBookingStatus(params, callback) {
    await Service.get(`api/v3/web/booking?${params}`, async (response) => {
      return callback(response);
    }).catch((error) => {
      return callback(error)
    });
  }

  async getspacelist(params, callback) {
    await Service.get(`api/v3/web/spacelist?${params}`, async (response) => {
      return callback(response);
    }).catch((error) => {
      return callback(error)
    });
  }

  async getCityListDayPass(payload, callback) {
    await Service.get("api/v3/web/daypass/citylist", payload, async (response) => {
      return callback(response);
    }).catch((error) => {
      return callback(error)
    });
  }

  async getCenterListDayPass(params, callback) {
    await Service.get(`api/v3/web/daypass/centrelist?${params}`, async (response) => {
      return callback(response);
    }).catch((error) => {
      return callback(error)
    });
  }

  async getLeadFormDayPass(payload, callback) {
    await Service.post('api/v3/web/visit',payload, async (response) => {
      return callback(response);
    }).catch((error) => {
      return callback(error)
    });
  }

  async getCenterDeatilsDayPass(params, callback) {
    await Service.get(`api/v3/web/daypass/centredetails?${params}`, async (response) => {
      return callback(response);
    }).catch((error) => {
      return callback(error)
    });
  }

  async getBookNowDayPass(params, callback) {
    await Service.get(`api/v3/web/daypass/availability?${params}`, async (response) => {
      return callback(response);
    }).catch((error) => {
      return callback(error)
    });
  }

  // async checkCoupoun(params, callback) {
  //   await Service.get(`api/v3/web/daypass/checkcoupon?${params}`, async (response) => {
  //     return callback(response);
  //   }).catch((error) => {
  //     return callback(error)
  //   });
  // }

  async dayPassBookingPayment(payload, callback) {
    await Service.post('api/v3/web/daypass/booking',payload, async (response) => {
      return callback(response);
    }).catch((error) => {
      return callback(error)
    });
  }

}



export default BookingStore;
